export async function getClientProductsUseCase(clientId, productRepository) {
    const result = await productRepository.get_products_by_client_id(clientId);

    result.forEach(x => {
        x = new productRepository.model_dropdown(x);

        if (!x.isValid()) {
            throw new Error("dropdown product inválido");
        }
    })

    return result;
}